export default "__VITE_ASSET__Bl0T5UHL__"